import styled from 'styled-components';

export const QuoteCardStyled = styled.div(({ theme }) => ({
  borderRadius: 4,
  display: 'flex',
  overflow: 'hidden',
  flexDirection: 'column',
  paddingTop: theme.space[5],
  border: `1px solid ${theme.color.wfGrey400}`,
  '&:not(:last-child)': {
    marginBottom: theme.space[4],
  },
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
}));

export const CardFooterStyled = styled.div(({ theme }) => ({
  padding: `${theme.space[3]} ${theme.space[5]}`,
  background: theme.color.wfGrey100,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));
